class SpeedSocietyOffer extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }
  
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    
    // Wait for DOM to fully load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }
  
  init() {
    // Get section ID
    this.sectionId = this.getAttribute('section-id');
    
    if (!this.sectionId) {
      console.error('SpeedSocietyOffer: No section-id attribute provided');
      return;
    }
    
    // Initialize functionality
    this.setupBuyNowButtons();
  }
  
  setupBuyNowButtons() {
    const itemImages = document.querySelectorAll('.item-parent');

    itemImages.forEach(image => {
      image.addEventListener('click', (event) => {
        // Prevent default image action
        event.preventDefault();

        // Add loading state to the clicked item
        image.classList.add('is-loading');
        
        // Get product data from image attributes
        const variantId = image.getAttribute('data-variant-id');
        const sellingPlanId = image.getAttribute('data-selling-plan');
        const entries = image.getAttribute('data-entry');
        const giveaway = image.getAttribute('data-giveaway');
        
        if (!variantId) {
          console.error('SpeedSocietyOffer: No variant ID found');
          image.classList.remove('is-loading');
          return;
        }
        
        // Create cart data object
        let formData = {
          'items': [{
            'id': variantId,
            'quantity': 1,
            'properties': {}
          }]
        };
        
        // Add properties if they exist (use configured giveaway property name)
        if (entries && entries !== 'null' && entries !== 'undefined') {
          const propertyName = window.entries?.giveaway_name || 'Entries';
          let entriesValue = entries;
          const tierMultiplier = parseInt(window.entries?.customer_tier_multiplier, 10);
          if (!Number.isNaN(tierMultiplier) && tierMultiplier > 1) {
            const base = parseInt(String(entries).replace(/,/g, ''), 10);
            if (!Number.isNaN(base)) entriesValue = String(base * tierMultiplier);
          }
          formData.items[0].properties[propertyName] = entriesValue;
        }
        
        // Add giveaway property if it exists
        if (giveaway && giveaway !== 'null' && giveaway !== 'undefined') {
          formData.items[0].properties['Giveaway'] = giveaway;
        }
        
        // Add selling plan if it exists (for subscription products)
        if (sellingPlanId && sellingPlanId !== 'null' && sellingPlanId !== 'undefined') {
          formData.items[0].selling_plan = sellingPlanId;
        }
        
        // Add to cart and redirect to cart page
        this.addToCart(formData, image);
      });
    });
  }
  
  addToCart(formData, element) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (response.ok) {
        const event = new CustomEvent('speed-society:product-added', {
          bubbles: true,
          detail: { formData }
        });
        this.dispatchEvent(event);

        return this.syncShippingProtection()
          .then(() => {
            if (typeof window.syncCartEntries === 'function') {
              return window.syncCartEntries();
            }
          })
          .finally(() => {
            window.location.href = '/cart';
          });
      } else {
        return response.json().then(data => {
          throw new Error(data.description || 'Could not add product to cart');
        });
      }
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
      element.classList.remove('is-loading');
      alert(error.message || 'Could not add product to cart. Please try again.');
    });
  }

  async syncShippingProtection() {
    const sp = window.shippingProtection;
    if (!sp?.status || !sp?.product?.variant_id) return null;

    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const alreadyInCart = cart.items.some(
        (item) => item.variant_id === sp.product.variant_id
      );
      if (alreadyInCart) return null;

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: sp.product.variant_id, quantity: 1 }),
      });
      if (!addRes.ok) {
        console.warn('[SP] Add failed:', await addRes.text());
        return null;
      }
      return await addRes.json();
    } catch (e) {
      console.error('[SP] Sync failed:', e);
      return null;
    }
  }
  
  disconnectedCallback() {
    // Clean up if needed when component is removed
  }
}

// Register the custom element
customElements.define('speed-society-offer', SpeedSocietyOffer);